/**
 * @file HomeHeaderView.tsx
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Avatar from "@mui/material/Avatar";
import MenuItem from "@mui/material/MenuItem";
import "./../Header.css"
import { Button, CssBaseline, ThemeProvider } from "@mui/material";
import React from "react";
import { roboto900Text14 } from "../../utils/theme/CommonTheme";

const settings = ["Settings", "Sign out"];

/**
 * A function component for HomeHeaderView
 * @param props 
 * @returns 
 */
export function HomeHeaderView(props) {

      const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

      /**
       * Handles open user menu
       * @param event MouseEvent
       */
      const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
      };

      /**
       * Handles close user menu
       */
      const handleCloseUserMenu = () => {
        setAnchorElUser(null);
      };

      /**
       * Handles memu item"s click event
       * @param event 
       */
      const onClickedMenuItems = (event) => {
        if (event.currentTarget.dataset.myValue === "Sign out") {
            props.logoutUser();   /* eslint-disable-line */
        } else if(event.currentTarget.dataset.myValue === "Settings"){
            props.openSetting();  /* eslint-disable-line */
        }
      };

      /**
       * Handles click more event
       */
      const onClickMore = () => {
        props.showMore();  /* eslint-disable-line */
      };

      /**
       * Get Two letters name
       * @param row AdminRow
       * @returns string
       */
      const getTwoLetterName = (firstName: string, lastName: string)=> {
        return `${isEmpty(firstName) ? "N" : firstName.substring(0,1)} ${isEmpty(firstName) ? "A" : lastName.substring(0,1)}`.toUpperCase();
      }

      const isEmpty = (str) => {
        return (!str || str.length === 0);
      }
      /**
       * Handles open home event
       */
      const openHome = () => {
        props.openHome();  /* eslint-disable-line */
      };

      /**
       * Returns selected clinic name
       * @returns Selected clinic name
       */
      const getSelectedClinicName = ()=> {
          if(!props){
            return ""
          }
          /* eslint-disable-next-line */
          return !props.selectedClinicName ? "" : props.selectedClinicName;
      }
      

  return (
    <div className="HomeAppBar">
      <CssBaseline />
      <AppBar position="fixed" style={{ width: "100%" }} elevation={0}>
        <Toolbar disableGutters variant="dense" className="HomeToolBar" style={{ width: "100%" }}>
          <img src="/../log_header.svg" className="HeaderBridgeLogo" alt="" onClick={openHome}/>
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "flex" }, alignItems: "center" }} >
            <Typography style={{marginLeft: "30px"}} className="ClinicName" sx={{ textTransform: "capitalize"}}>
               {getSelectedClinicName()}
            </Typography>
            {/* eslint-disable-next-line */}
            {props && props.clinics && props.clinics.length > 1 && props.enableClinicSelection && <Button onClick={onClickMore}>
              <Avatar alt="More" src="/../more.svg" className="Avator" />
            </Button>}
          </Box>

          <Box sx={{ flexGrow: 0 }} className="more-setting">
           <IconButton sx={{ p: 0 }}> 
             <ThemeProvider theme={roboto900Text14}>
                <Avatar className="Avator" sx={{ background: "#045B6C", letterSpacing: "-1px", fontSize:"0.6em", height: "4.5vh", width: "4.5vh" }}>
                    {/* eslint-disable-next-line */}
                  { getTwoLetterName(props.firstName, props.lastName)}
                </Avatar>
              </ThemeProvider>
            </IconButton>
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar src="/../down_arrow.svg" className="AvatorDownArrow" sx={{height: "20px", width: "20px"}}/>
            </IconButton>    
          </Box>
          <Menu
              sx={{ mt: "45px" }} id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              disableScrollLock={true}
              open={Boolean(anchorElUser)}
              onClick={handleCloseUserMenu}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} data-my-value={setting}
                  onClick={onClickedMenuItems}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
        </Toolbar>
      </AppBar >
    </div>
  );
}